import React from "react";
import { Box, Divider, useMediaQuery, Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const PublicResultsFooter = ({ footerLogos = [] }) => {
  const theme = useTheme();
  const isBelowMd = useMediaQuery("(max-width:899px)");

  // Enable animation only if more than 2 logos on mobile
  const shouldAnimate = isBelowMd && footerLogos.length > 2;
  // Duplicate logos multiple times for seamless infinite scroll
  const logos = shouldAnimate ? [...footerLogos, ...footerLogos, ...footerLogos, ...footerLogos] : footerLogos;

  return (
    <Grid container sx={{ py: 0, overflow: 'hidden' }}>
      <Grid item xs={12}>
        <Box
          className="ty_pr_footer_container"
          sx={{
            overflow: "hidden",
            width: "100%",
            position: "relative",
          }}
        >
          <Box
            className="ty_pr_footer_logos"
            sx={{
              display: "flex",
              justifyContent: isBelowMd ? "flex-start" : "center",
              alignItems: "center",
              gap: isBelowMd ? 0 : 2,
              overflow: "hidden",
              width: "100%",
            }}
          >
            {isBelowMd ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  animation: shouldAnimate ? "scrollLogos 20s linear infinite" : "none",
                  willChange: shouldAnimate ? "transform" : "auto",
                  "@keyframes scrollLogos": {
                    "0%": { transform: "translateX(0)" },
                    "100%": { transform: "translateX(-25%)" },
                  },
                }}
              >
                {logos.map((logo, index) => (
                  <Box
                    key={`${logo}-${index}`}
                    sx={{
                      flex: "0 0 auto",
                      px: 3,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minWidth: "120px",
                    }}
                  >
                    <img
                      src={logo}
                      alt={`logo-${index}`}
                      style={{
                        height: "60px",
                        width: "auto",
                        maxWidth: "100px",
                        objectFit: "contain",
                        display: "block",
                      }}
                    />
                  </Box>
                ))}
              </Box>
            ) : (
              footerLogos.map((logo, index) => (
                <React.Fragment key={index}>
                  <img
                    src={logo}
                    alt={`logo-${index}`}
                    style={{
                      height: "60px",
                      width: "auto",
                      maxWidth: "150px",
                      objectFit: "contain",
                    }}
                  />
                  {index < footerLogos.length - 1 && (
                    <Divider orientation="vertical" variant="middle" flexItem />
                  )}
                </React.Fragment>
              ))
            )}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default PublicResultsFooter;
